<template>
  <div>
    <el-form class="toolbar" :inline="true" @keyup.enter.native="query">
      <el-form-item label="物料" required>
        <el-input v-model="materialCode" readonly size="small" style="width:200px" placeholder="点击选择">
          <el-button slot="append" @click="materialSelectorVisible = true">选择</el-button>
        </el-input>
      </el-form-item>
      <el-form-item label="BOM类型">
        <el-select v-model="bomType" size="small" style="width:100px">
          <el-option label="MBOM" value="mbom" /><el-option label="EBOM" value="ebom" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button v-if="isAuth('plm:plmChangeImpact:list')" type="primary" size="small" :loading="loading" @click="query">分析</el-button>
      </el-form-item>
    </el-form>
    <el-alert title="向上逐层查询所选 BOM 类型的全部版本。上层物料的在制工单和销售单仅为候选关联，需核对实际投产 BOM 版本；采购单只查询该物料本身。" type="info" :closable="false" show-icon style="margin-bottom:12px" />
    <material-selector :visible.sync="materialSelectorVisible" :multiple="false" @select="onMaterialSelect" />

    <template v-if="impact">
      <el-descriptions :column="3" border size="small" style="margin-bottom:12px">
        <el-descriptions-item label="物料">{{ impact.materialCode }} / {{ impact.materialName }}</el-descriptions-item>
        <el-descriptions-item label="BOM范围">全部版本</el-descriptions-item>
        <el-descriptions-item label="现存量">{{ impact.inventoryQty }}</el-descriptions-item>
      </el-descriptions>
      <el-tabs>
        <el-tab-pane :label="'上层引用 (' + (impact.whereUsed || []).length + ')'">
          <el-table :data="impact.whereUsed || []" border size="small" :header-cell-style="headStyle">
            <el-table-column prop="depth" label="层级" width="70" header-align="center" align="center" />
            <el-table-column prop="materialCode" label="父件编码" min-width="120" header-align="center" />
            <el-table-column prop="materialName" label="父件名称" min-width="140" header-align="center" />
            <el-table-column prop="referencePath" label="引用路径" min-width="220" header-align="center" show-overflow-tooltip />
            <el-table-column prop="bomVersion" label="版本" width="80" header-align="center" align="center" />
            <el-table-column prop="bomType" label="类型" width="80" header-align="center" align="center" />
            <el-table-column label="审批" width="80" header-align="center" align="center">
              <template slot-scope="scope">{{ scope.row.approveStatus === '2' ? '已审' : '未审' }}</template>
            </el-table-column>
            <el-table-column label="发布" width="80" header-align="center" align="center">
              <template slot-scope="scope">{{ scope.row.releaseStatus === '1' ? '是' : '否' }}</template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane :label="'在制工单 (' + (impact.openProductionOrders || []).length + ')'">
          <el-table :data="impact.openProductionOrders || []" border size="small" :header-cell-style="headStyle">
            <el-table-column prop="productionOrderCode" label="工单号" min-width="130" header-align="center" />
            <el-table-column prop="materialCode" label="产品编码" min-width="120" header-align="center" />
            <el-table-column prop="relationScope" label="关联范围" min-width="120" header-align="center" />
            <el-table-column prop="bomVersion" label="BOM版本" width="90" header-align="center" align="center" />
            <el-table-column prop="planQty" label="计划量" width="90" header-align="center" align="center" />
            <el-table-column prop="orderStatus" label="状态" width="80" header-align="center" align="center">
              <template slot-scope="scope">{{ orderStatusLabel(scope.row.orderStatus) }}</template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane :label="'未结采购 (' + (impact.openPurchaseLines || []).length + ')'">
          <el-table :data="impact.openPurchaseLines || []" border size="small" :header-cell-style="headStyle">
            <el-table-column prop="docCode" label="采购单号" min-width="130" header-align="center" />
            <el-table-column prop="quantity" label="未收数量" width="100" header-align="center" align="center" />
          </el-table>
        </el-tab-pane>
        <el-tab-pane :label="'未结销售 (' + (impact.openSalesLines || []).length + ')'">
          <el-table :data="impact.openSalesLines || []" border size="small" :header-cell-style="headStyle">
            <el-table-column prop="docCode" label="销售单号" min-width="130" header-align="center" />
            <el-table-column prop="materialCode" label="产品编码" min-width="120" header-align="center" />
            <el-table-column prop="relationScope" label="关联范围" min-width="120" header-align="center" />
            <el-table-column prop="quantity" label="未出库数量" width="110" header-align="center" align="right" />
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </template>
  </div>
</template>

<script>
import request from '../../api/request'
import { fetchPerms } from '../../api/auth'
import MaterialSelector from '../../components/MaterialSelector.vue'

export default {
  name: 'PlmChangeImpact',
  components: { MaterialSelector },
  data() {
    return {
      materialId: '', materialCode: '', bomType: 'mbom',
      impact: null, loading: false, materialSelectorVisible: false, permCodes: [],
      headStyle: { background: '#f5f7fa', color: '#606266', textAlign: 'center' }
    }
  },
  created() { this.loadPerms() },
  methods: {
    isAuth(perm) {
      const user = this.$store.state.user || {}
      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []
      if (['TENANT_ADMIN', 'PLATFORM_ADMIN'].indexOf(String(user.roleCode || '')) >= 0 || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true
      return this.permCodes.indexOf(perm) >= 0
    },
    loadPerms() { fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {}) },
    orderStatusLabel(s) {
      const map = { '0': '草稿', '1': '已下达', '3': '已完工', '4': '已关闭' }
      return map[s] || s
    },
    onMaterialSelect(row) {
      this.materialId = row.materialId
      this.materialCode = row.materialCode
      this.materialSelectorVisible = false
    },
    query() {
      if (!this.materialId) { this.$message.warning('请选择物料'); return }
      this.loading = true
      request.get('/plm/impact/query', {
        params: { materialId: this.materialId, bomType: this.bomType || 'mbom' }
      }).then(res => { this.impact = res.data || null }).catch(() => { this.impact = null }).finally(() => { this.loading = false })
    }
  }
}
</script>

<style scoped>
.toolbar >>> .el-form-item { margin-bottom: 8px; }
</style>
